import { ValidationErrors } from "final-form";
import { Form } from "react-final-form";
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import keycloak from "../../keycloak";
import { FieldConfigDto } from "../../store/models/FieldConfigDto";
import { RegistrationDto } from "../../store/models/RegistrationDto";
import NotificationList from "../notification/NotificationList";
import Contact from "./Contact";
import { GiftCardNumbersField } from "./GiftCardNumbersField";
import PersonalData from "./PersonalData";
import Registration from "./Registration";
import { RegistrationFormThunkProps } from "./RegistrationFormContainer";
import { getGiftCardsFromUrl } from "./registrationUrlParams";
import {
  isFieldMandatory,
  isFieldNeeded,
  validateDateOfBirth,
  validateMandatory,
  validateName,
  validateRegistration,
} from "./Validation";

export function getLabelText(labelName: string, fieldName: string, registrationFieldConfig: FieldConfigDto[]) {
  return labelName + (isFieldMandatory(fieldName, registrationFieldConfig) ? " *" : "");
}
export const RegistrationForm = (props: RegistrationFormThunkProps) => {
  const register = async (values: RegistrationDto) => {
    const { thunkRegistration } = props;
    const cleanedGiftCards = values.giftCards
      ?.map((giftCard) => ({ giftCardNumber: giftCard?.giftCardNumber?.trim() ?? "", pinCode: giftCard?.pinCode }))
      .filter((giftCard) => giftCard.giftCardNumber.length > 0);
    const payload: RegistrationDto = {
      ...values,
      giftCards: cleanedGiftCards && cleanedGiftCards.length > 0 ? cleanedGiftCards : undefined,
    };
    if (!payload.giftCards) {
      delete payload.giftCards;
    }
    const success = await thunkRegistration(payload);
    if (success) {
      keycloak.login();
    }
  };

  const { registration, registrationFieldConfig } = props;

  // Prefill gift cards (number + PIN) from a personalized registration link.
  const urlGiftCards = getGiftCardsFromUrl(globalThis.location.search);

  const validate = (registration: RegistrationDto) => {
    const errors: ValidationErrors = {};

    validateMandatory(errors, registration, registrationFieldConfig);
    validateRegistration(errors, registration.login.password, registration.login.passwordConfirm);
    validateName(errors, registration.firstName, registration.lastName);
    validateDateOfBirth(errors, registration.dateOfBirth);

    return errors;
  };
  return (
    <div className="jumbotron">
      <h1>Registrierung</h1>
      <Form
        onSubmit={register}
        initialValues={urlGiftCards.length > 0 ? { ...registration, giftCards: urlGiftCards } : registration}
        validate={validate}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Registration {...props} />
            <PersonalData {...props} />
            <Contact {...props} />
            {/* "giftCardNumbers" is the server-side field config key (uppercased to GIFTCARDNUMBERS) gating this section. */}
            {(isFieldNeeded("giftCardNumbers", registrationFieldConfig) || urlGiftCards.length > 0) && (
              <Card id="giftCards" className="mb-5">
                <CardBody>
                  <CardTitle>Geschenkkartennummern</CardTitle>
                  <GiftCardNumbersField />
                </CardBody>
              </Card>
            )}
            <Row style={{ paddingBottom: 16 }}>
              <Col md={{ size: 12 }}>
                <NotificationList />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Button type="submit">Registrieren</Button>
              </Col>
            </Row>
          </form>
        )}
      />
    </div>
  );
};
